import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";
import Pagination from "react-js-pagination";

export default function Announcement(prop) {

    let [listing, setListing] = React.useState(null);

    let [itemPerpage, setItemPerpage] = React.useState(12);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);

    React.useEffect(() => {

        (async function() {
            try {
                const resListing = await getListing();
                setListing(resListing);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    async function getListing(pageNum) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        const response = await fetch(Config.apiUrl +'announcement/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'News':'ข่าวสาร'} / {prop.lang === 'en' ? 'Announcement':'ประกาศจาก ศชวซ.'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Announcement':'ประกาศจาก ศชวซ.'}</span>
                    </h1>
                </div>
            </div>


            <div className="section bg-light">
                <div className="container">
                    <h2 className="text-center text-primary mb-sm-4 mb-3">{prop.lang === 'en' ? 'Announcement':'ประกาศจาก ศชวซ.'}</h2>

                    <div className="row g-3">
                        {
                            listing !== null && listing.count > 0 ?
                                <>
                                    {
                                        listing.rows.map((row, index) => {
                                            return (
                                                <div key={index} className="col-12">
                                                    <div className="card-announcement">
                                                        <a href={(prop.lang === 'en' ? '/en':'') + '/announcement/detail/' + row.slug} className="card-link"></a>
                                                        <div className="card-date">
                                                            <p>{Utils.getDay(row.postDate)}</p>
                                                            <p>{Utils.getMonthYearShort(row.postDate, prop.lang)}</p>
                                                        </div>
                                                        <div className="card-body">
                                                            <h3>{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</h3>

                                                            <p className="readmore">
                                                                <span>{prop.lang === 'en' ? 'Read more':'อ่านต่อ'}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </> : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                        }
                    </div>

                    <div className={totalPage > 1 ? '':'d-none'}>
                        <Pagination
                            itemClassPrev="arrow prev"
                            itemClassNext="arrow next"
                            activeClass="active"
                            itemClass=""
                            linkClass=""
                            innerClass="pagination"
                            activePage={activePage}
                            itemsCountPerPage={itemPerpage}
                            totalItemsCount={countAllItem}
                            pageRangeDisplayed={5}
                            onChange={(pageNum) => onPageChange(pageNum)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
} 